<template>
  <div v-show="item">
    <peaks-player v-if="item.waveform" :asset="{...item, path: item.storage_url}">
      <template #player_portlet_actions>
        <a
          v-perms="['web.storage.download']" :href="`/storage/massDownload?selected=${item.uuid}`"
          target="_blank"
          class="btn btn-ss btn-icon" alt="Download File">
          <i class="fa fa-download" />
        </a>
      </template>
    </peaks-player>
    <basic-portlet v-else title="Waveform:" icon="fa fa-signal">
      <strong>Waveform not generated</strong><br>
      <button class="btn btn-ss-standout mt-4" @click="generateWaveform()">
        Generate Now
      </button>
    </basic-portlet>

    <collapse-portlet title="Clips" icon="la la-cut" :expanded="false">
      <clip v-if="!extension_is_banned" :item="item" />
      <span v-else>Cannot create clips for this file type ({{ file_extension }}).</span>
    </collapse-portlet>
    <collapse-portlet title="Converter" icon="la la-exchange" :expanded="false">
      <converter v-if="!extension_is_banned" :item="item" />
      <span v-else>Cannot modify bitrate / gain for this file type ({{ file_extension }}).</span>
    </collapse-portlet>

    <meta-data v-if="item.ffmpeg_details" :storage-uuid="item.uuid" />
    <quick-alert-modal v-bind="quick_alert" />
    <waveform-generating-modal />
    <vjs-modal name="waveform_generation_failed" title="Waveform Generation Failed">
      <template #body-content>
        <p>
          We were unable to generate the waveform. Please contact SharpStream Support.
        </p>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import VueEvents from 'vue-events';
import Clip from "VuePartials/App/Ffmpeg/Clip";
import Converter from "VuePartials/App/Ffmpeg/Converter";
import MetaData from "VuePartials/App/Ffmpeg/MetadataForm";
import BasicPortlet from "VueComponents/BasicPortlet";
import CollapsePortlet from "VueComponents/CollapsePortlet";
import PeaksPlayer from 'VuePartials/App/Chapters/PeaksPlayer';
import VjsModal from "VueModals/VjsModal";
import WaveformGeneratingModal from "VueModals/WaveformGeneratingModal";

Vue.use(VueEvents);

export default {
  components: {
    BasicPortlet,
    Clip,
    CollapsePortlet,
    Converter,
    MetaData,
    PeaksPlayer,
    VjsModal,
    WaveformGeneratingModal,
  },
  data: () => ({
    item: _.cloneDeep(window.item),
    banned_file_extensions: ['mp4'],
  }),
  computed: {
    file_extension() {
      const name = this.item.name;
      return name.slice(name.lastIndexOf('.') + 1).toLowerCase();
    },
    extension_is_banned() {
      return this.banned_file_extensions.includes(this.file_extension);
    },
  },
  mounted() {
    EventBus.$on(`waveform_complete_${this.item.uuid}`, () => {
      this.hideModal("waveform_generating");
      window.location.reload();
    });

    EventBus.$on(`waveform_error_${this.item.uuid}`, () => {
      this.hideModal("waveform_generating");
      this.fireModal("waveform_generation_failed");
    });
  },
  methods: {
    generateWaveform() {
      axios.post(`/api/v1/storage/${this.item.uuid}/generate-waveform`).then(() => {
        this.fireModal('waveform_generating');
      }).catch(() => {
        this.fireModal('waveform_generation_failed');
      });
    },
  },

};

</script>
